var exports = {
  "p": "x28a7bf27--8c7f9f--list",
  "A": "x28a7bf27--8c7f9f--item",
};

module.exports = exports;
